export const LS_UTM_PARAMS = 'utmParams';
export const LS_INTERFACE_LANGUAGE = 'interfaceLanguage';
